module.exports = __webpack_public_path__ + "img/blog-8.06a770dc.webp";